import { render } from "./Credit.vue?vue&type=template&id=d54b5bf2"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"

import "./Credit.vue?vue&type=style&index=0&id=d54b5bf2&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__